function HttpUrls() {
	//用户
	this.loginUrl = '/login/toLogin';
	this.outLogin = '/user/myLogout';
	this.roleGetUrl = '/businessManagement/roleManagement/getRoles';
	this.userInfo = '/user/getUserInfo';
	this.selfMenu = '/businessManagement/roleManagement/selfMenu';

	//角色
	this.menuByRole = '/businessManagement/roleManagement/getMenuByRole';
	this.addRole = '/businessManagement/roleManagement/addRole';
	this.deleteRole = '/businessManagement/roleManagement/deleteRole';
	this.updateMenuByRole = '/businessManagement/roleManagement/updateMenuByRole';

	//部门
	this.getDeptList = '/businessManagement/departmentManagement/list_all';
	//部门模糊查询
	this.searchUserByDeptId = '/businessManagement/departmentManagement/searchByDepId';
	this.addDept = '/businessManagement/departmentManagement/save';
	this.updateDept = '/businessManagement/departmentManagement/update';
	this.delDept = '/businessManagement/departmentManagement/delete';
	//添加人员到部门
	this.addUserInDept = '/businessManagement/departmentManagement/addUserByDep';
	//删除部门人员
	this.delUserInDept = '/businessManagement/departmentManagement/deleteUserByDep';

	//用户
	this.searchUserByName = '/businessManagement/userManagement/searchByName';
	this.editUserData = '/businessManagement/userManagement/update';
	this.addUserData = '/businessManagement/userManagement/addUser';
	//重置密码
	this.resetUserPass = '/businessManagement/userManagement/resetPassword';
  this.userDisable = '/businessManagement/userManagement/disable';
  // 删除用户
  this.delUserData = '/user/del';
	//获取用户所有信息
	this.getUserDataAllInfo = '/businessManagement/userManagement/info';
	//获取所有用户
	this.getAllUser = '/businessManagement/userManagement/getAllUser';

	//登录日志管理
	this.selectLoginLog = '/businessManagement/loginLog/searchByName';

	//公司配置接口
	this.companyInfo = '/businessManagement/companyManagement/info';
	this.companyUpdate = '/businessManagement/companyManagement/update';

	//文件接口
	//上传图片
	this.uploadImage = '/businessManagement/companyManagement/uploadImage';
	//获取所有图片
	this.geImageAll = '/businessManagement/companyManagement/image/list_all';
	//删除图片
	this.delImage = '/businessManagement/companyManagement/delete/';


	//设备管理接口
	this.repaiReport = '/deviceManagement/faultRepair/list_all'; //获取故障报修信息
	this.addReport = '/deviceManagement/faultRepair/save'; //添加故障报修信息
	this.changeReport = '/deviceManagement/faultRepair/update'; //修改故障报修信息
	this.getReportNo = '/deviceManagement/faultRepair/getAllLedge' //获取所有设备位号

	//工单
	this.getHandleMes = '/deviceManagement/serviceOrder/list_all' //获取维修工单信息
	this.addHandleMes = '/deviceManagement/serviceOrder/save' //新增工单信息
	this.editFinishWork = '/deviceManagement/serviceOrder/finishSure'	//完成工单

	this.delInfo = '/deviceManagement/faultRepair/delete/' //删除故障报修

	//设备分类
	this.getdeviceClass = '/deviceManagement/deviceClass/class/list_all'
	this.adddeviceClass = '/deviceManagement/deviceClass/save' //添加设备分类详细信息
	this.changedeviceClass = '/deviceManagement/deviceClass/update' //修改设备分类详细信息
	this.deldeviceClass = '/deviceManagement/deviceClass/delete/' //删除详细信息

	this.addClass = '/deviceManagement/deviceClass/class/save' //添加设备
	this.changeClass = '/deviceManagement/deviceClass/class/update' //	修改设备
	this.delClass = '/deviceManagement/deviceClass/class/delete/' //删除设备

	//设备台账
	this.getDevLeder = '/deviceManagement/deviceLedger/selectByName' //获取
	this.addDevLeder = '/deviceManagement/deviceLedger/save' //添加
	this.delDevLeder = '/deviceManagement/deviceLedger/delete/' //删除
	this.changeDevLeder = '/deviceManagement/deviceLedger/update' //修改


	//信息维护
	this.getProfession = '/deviceManagement/infoService/overhaulProfession/list_all' //获取检修信息
	this.getProInfo = '/deviceManagement/infoService/overhaulProfession/list_all' //获取检修专业信息
	this.addProInfo = '/deviceManagement/infoService/overhaulProfession/save' //添加检修专业信息
	this.changeProInfo = '/deviceManagement/infoService/overhaulProfession/update' //修改检修专业信息
	this.delProInfo = '/deviceManagement/infoService/overhaulProfession/delete/' //删除检修专业信息

	//区域
	this.getarea = '/deviceManagement/infoService/area/list_all' //获取区域信息
	this.getAreaInfo = '/deviceManagement/infoService/area/list_all' //获取区域信息分页
	this.addAreaInfo = '/deviceManagement/infoService/area/save' //添加区域信息
	this.changeAreaInfo = '/deviceManagement/infoService/area/update' //修改区域信息
	this.delAreaInfo = '/deviceManagement/infoService/area/delete/' //删除区域信息

	//维修
	this.getServiceType = '/deviceManagement/infoService/serviceType/list_all' //获取维修类别
	this.addserviceType = '/deviceManagement/infoService/serviceType/save' //添加维修类别
	this.changeserviceType = '/deviceManagement/infoService/serviceType/update' //修改维修类别
	this.delserviceType = '/deviceManagement/infoService/serviceType/delete/' //删除维修类别


	//作业
	this.getticketType = '/deviceManagement/infoService/workTicket/list_all' //获取作业票
	this.addticketType = '/deviceManagement/infoService/workTicket/save' //添加作业票
	this.changeticketType = '/deviceManagement/infoService/workTicket/update' //修改作业票
	this.delticketType = '/deviceManagement/infoService/workTicket/delete/' //删除作业票

	//三卡管理
	//获取承诺卡
	this.getProCard = '/promisecard/getAll'
	//分页获取承诺卡
	this.getPromisecard = '/promisecard/list_all'
	this.addPromisecard = '/promisecard/save'
	this.delPromisecard = '/promisecard/delete/'
	this.changePromisecard = '/promisecard/update'

	//应急卡
	this.getAllEmgCard = '/emergencycard/getAll'
	//分页获取应急卡
	this.getEmergecard = '/emergencycard/list_all'
	this.addEmergecard = '/emergencycard/save'
	this.delEmergecard = '/emergencycard/delete/'
	this.changeEmergecard = '/emergencycard/update'

	//应知卡
	this.getAllKnownCard = '/shouldknowcard/getAll'
	//分页获取应知卡
	this.getKonwnCard = '/shouldknowcard/list_all'
	this.addKonwnCard = '/shouldknowcard/save'
	this.delKonwnCard = '/shouldknowcard/delete/'
	this.changeKonwnCard = '/shouldknowcard/update'

  // 安全风险管控
  // 新增风险研判
  this.addRisk = '/researchvote/save '


	///人员管理
	//添加人员
	// this.addEmployeeList = '/v1/save'
	// //获取人员
	// this.getEmployeeList = '/list_all'
	this.getAllEmployeeList = '/employee/getAll'
	// //编辑人员
	// this.changeEmployeeList = '/v1/update'
	// //删除人员
	// this.delEmployeeList = '/v1/delete/'
	// //上传头像
	// this.sendImgEmployee = '/v1/uploadImg'


	//部门管理

	//分页获取部门
	this.getEmpInfo = '/emploteedepartment/list_all'
	//删除部门
	this.delEmpInfo = '/emploteedepartment/delete/'
	//添加部门
	this.addEmpInfo = '/emploteedepartment/save'
	//修改部门
	this.changeEmpInfo = '/emploteedepartment/update'
	//获取所有部门
	this.getAllEmplotee = '/emploteedepartment/getAll'


	//获取法律法规
    this.getLegislation = '/lawsRegulations/list_all'
	//添加法律法规
    this.saveLegislation = '/lawsRegulations/save'
	//删除法律法规
    this.deleteLegislation = '/lawsRegulations/delete/'

	//获取责任书
    this.getResponsibility = '/responsibilitybook/list_all'
	//添加责任书
    this.saveResponsibility = '/responsibilitybook/save'

	//获取计划
    this.getGoalPlan = '/goalplan/list_all'
	//添加计划
    this.saveGoalPlan = '/goalplan/save'

	//获取安全制度
    this.getSafety = '/safety/search'
	 //获取安全制度
    this.saveSafety = '/safety/save'

	//获取题目
    this.getQuestion = '/questionbank/list_all'
    this.saveQuestion = '/questionbank/save'

    //获取问卷
    this.getQuestionnaire = '/questionnaire/list_all'
    this.saveQuestionnaire = '/questionnaire/save'

    //考试记录
    this.getExamrecord = '/examrecord/list_all'
    this.saveExamrecord = '/examrecord/save'

    // 删除培训记录
    this.delPxRecord = '/cultivateHistory/deleteEmp/'

    //扫码考试记录
    this.getScancodeexamrecord = '/scancodeexamrecord/list_all'
    this.saveExamrecord = '/examrecord/save'

    //证书管理
    this.getCertificate = '/certificate/list_all'
    this.saveCertificate = '/certificate/save'

    //事故快报
    this.getAccidentBulletin = '/accidentBulletin/list_all'
    this.saveAccidentBulletin = '/accidentBulletin/save'

    //事故报告
    this.getAccidentReport = '/accidentReport/list_all'
    this.saveAccidentReport = '/accidentReport/save'
    this.getAllAccident = '/accidentBulletin/list_accident'
    this.getOneAccident = '/accidentBulletin/info/'

    //变更列表
    this.getmodifyform = '/modifyform/list_all'
    this.savemodifyform = '/modifyform/save'

    //变更验收
    this.getmodifyAccepting = '/modifyAccepting/list_all'
    this.savemodifyAccepting = '/modifyAccepting/save'

    //巡检点
    this.getinspectioncheckpoint = '/inspectioncheckpoint/list_all'
    this.saveinspectioncheckpoint = '/inspectioncheckpoint/save'

	//隐患
	//获取排查计划
	this.getDangerPlanListAll = '/troubleshootplan/list_all'
	//删除排查计划
	this.delDangerPlan = '/troubleshootplan/delete/'
	//新增排查计划
	this.addDangerPlan = '/troubleshootplan/save'
	//编辑排查计划
	this.updateDangerPlan = '/troubleshootplan/update'

	//获取隐患排查任务
	this.getDangerTaskListAll = '/troubleshoottask/list_all'

	//获取隐患类别
	this.getDangerTypeAll = '/hiddendanger/list_all'
	//更新隐患类别
	this.updateDangerType = '/hiddendanger/update'
	//更新隐患类别
	this.addDangerType = '/hiddendanger/save'
	//删除隐患类别
	this.delDangerType = '/hiddendanger/delete/'
	//获取检查标准
	this.getDangerDataCheck = '/hiddendanger/getCheckStandard/'
	//添加检查标准
	this.saveDangerDataCheck = '/checkstandard/save'
	//更新检查标准
	this.updateDangerDataCheck = '/checkstandard/update'
	//删除检查标准
	this.deleteDangerDataCheck = '/checkstandard/delete/'

}
const httpUrls = new HttpUrls();
export default httpUrls;
